import React from 'react';
import Problem from './Problem';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';

import { useContext } from 'react';
import { userContext } from '../App';

import "./CSS/ProblemList.css"

const ProblemList = ({problems}) => {

  const {user, setUser} = useContext(userContext)

  if(user === null) {
    return (
      <div style={{color: "black"}}>
        <p style={{paddingLeft: '20px'}}>
          Please Login To view the question
        </p>
        <hr />
        <p style={{paddingLeft: '20px'}}>
          <Link to="/auth">Login</Link>
        </p>
      </div>
    )
  }

  return (
      <div className='problem-list'>
        {problems.map( (problem) => <Problem key={uuidv4()} problem={problem}></Problem>)}
      </div>
  )
};

export default ProblemList;
